import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [lastScannedBarcode, setLastScannedBarcode] = useState("");
  const [jsonData, setJsonData] = useState();

  return (
    <AppContext.Provider
      value={{
        lastScannedBarcode,
        setLastScannedBarcode,
        jsonData,
        setJsonData,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
